// extracted by mini-css-extract-plugin
export default {"p-dialog-header-icons":"SelectPhoneModal_p-dialog-header-icons_qkZov","p-dialog-content":"SelectPhoneModal_p-dialog-content_UxhmO","rounded":"SelectPhoneModal_rounded_qirdP"};